const theme: Jss.Theme = {
  // see https://nimbus-website.netlify.app/design-tokens/color/ for docs
  palette: {
    primaryPure: '#0272D5',
    secondaryPure: '#2C3357',
    secondaryLighter: '#EEF1F7',
    neutralBackground: '#FAFAFA',
    nubeWhite: '#ECEBEC',
    white: '#ffffff',
    neutralBorder: '#BFBBBD',
  },
  font: {
    family: 'sans-serif',
    defaultSize: '14px',
    defaultColor: '#2C3357',
    subtitleColor: '#62595D',
    titleColor: '#2C3357',
    smallSize: '12px',
    mediumSize: '16px',
  },
  spacing: {
    xSmall: '8px',
    smaller: '12px',
    small: '16px',
    medium: '24px',
  },
};

export default theme;
